/**
 * Build a 1-2 letter avatar label from a patient payload.
 *
 * Reads firstName/lastName first, falls back to patientFirstName /
 * patientLastName for payloads coming from the table-cell context
 * (legacy currentPageContext shape). Returns "?" for anonymous /
 * missing patients so the avatar always has something to render.
 */
export const getPatientInitials = patient => {
  if (!patient || patient.isAnonymousPatient) return '?';
  const first = patient.firstName || patient.patientFirstName || '';
  const last = patient.lastName || patient.patientLastName || '';
  const f = first.trim().charAt(0).toUpperCase();
  const l = last.trim().charAt(0).toUpperCase();
  const result = `${f}${l}`;
  return result || '?';
};
